<template>
  <div style="padding: 20px 10px">
    <el-row>
      <el-col :span="8">
        {{trendItem.contractCode}}
      </el-col>
      <el-col :span="8" style="text-align:center;">
        {{ trendItem.contractCodeLabel||'&nbsp;' }}
      </el-col>
      <el-col :span="8">
        <div class="highlight_data" v-if="highlightData.value">
          <div class="value">{{highlightData.value}}</div>
          <div class="date">{{highlightData.date}}</div>
        </div>
      </el-col>
    </el-row>

    <div :id="chartId"
         style="width: 100%; height: 240px;">
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

// 曲线图
let lineOption = {
    tooltip: {
      trigger: "axis",
    },
    grid: {
      left: "60px",
      right: "20px",
      top: "20px",
      bottom: "30px"
    },
    calculable: true,
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        data: [],
        axisLine: {
          lineStyle: {
            color: "#606266"
          }
        },
        axisLabel: {
          // interval: 0 // 不间隔
          interval: 'auto'
        },
        axisTick: {
          show: false
        }
      }
    ],
    yAxis: [
      {
        name: "",
        type: "value",
        splitNumber: 3,
        axisLine: {
          lineStyle: {
            color: "#606266"
          }
        },
        // splitLine: {
        //   lineStyle: {
        //     type: "dashed",
        //     color: "#888"
        //   }
        // }
      }
    ],
    series: [
      {
        name: "报价",
        type: "line",
        smooth: true,
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#0886ED" },
            { offset: 0.6, color: "#EBEEF5" }
          ])
        },
        lineStyle: {
          color: '#0886ED',
          width: 1
        },
        itemStyle: {
          color: '#0886ED',
        },
        symbol: 'circle',
        symbolSize: [6, 6],
        data: []
      }
    ]
}

export default {
  components: {
  },
  props: {
    chartId: {
      type: String,
      default: 'orderPriceTrend'
    },
    trendItem: {
      type: Object,
      default: () => {}
    },
    waittTotal: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      highlightData: {},
      loadData: false,
      orderPriceTrend: null,
      trendJson: []
    }
  },
  watch: {
    trendItem: {
      handler (val) {
        console.log('0000000', val)
        if (val.contractCode) {
          this.getLineChartData(val.contractCode)
        }
      },
      // immediate: true
    }
  },
  mounted () {
    this.orderPriceTrend = echarts.init(document.getElementById(this.chartId))

    if (this.trendItem.contractCode) {
      this.getLineChartData(this.trendItem.contractCode)
    }

    window.onresize = () => {
      this.orderPriceTrend.resize()
    }
  },
  methods: {
    getLineChartData (contractCode) {
      this.trendJson = []
      this.loadData = true
      this.$http({
        url: this.$http.adornUrl("/crmapi/bas/bulkFutures/list"),
        method: "post",
        data: {
          isPage: false,
          orderByAsc: 'bizDate',
          data: {
            contractCode,
          }
        },
      }).then(({ data }) => {
        if (data && data.code === "C0000") {
          this.trendJson = data.result.list || []
          this.setLineChart()

        } else {
          this.$message.error(data.message);
        }
      }).finally(() => {
        this.loadData = false;
      })
    },
    // K线图
    setLineChart () {
      if (!this.trendJson || !this.trendJson.length) {
        return
      }
      let options = _.cloneDeep(lineOption)
      options.xAxis[0].data = this.trendJson.map(item => item.bizDate)

      options.series[0].data = this.trendJson.map(item => item.todaySettle)

      options.series = options.series[0]
      this.orderPriceTrend.setOption(
        options,
        true
      );

      // 默认显示最后一条数据
      let index = options.series.data.length - 1
      this.$set(this.highlightData, 'date', options.xAxis[0].data[index])
      this.$set(this.highlightData, 'value', options.series.data[index])

      this.orderPriceTrend.on('highlight', (params) => {
        const batch = params.batch[0]
        const { dataIndex } = batch
        this.$set(this.highlightData, 'date', options.xAxis[0].data[dataIndex])
        this.$set(this.highlightData, 'value', options.series.data[dataIndex])
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.highlight_data{
  text-align: right;
  .value{
    font-size: 24px;
    color: #0886ED;
  }
  .date{
    font-size: 14px;
    color: #888;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/line-chart.vue